export let simplify = true;
export let reverse = true;
export let installPrompts = true;
export let autoChange = true;